"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PropertyUsed;
var _react = _interopRequireWildcard(require("react"));
var _Row = _interopRequireDefault(require("react-bootstrap/Row"));
var _Col = _interopRequireDefault(require("react-bootstrap/Col"));
var _Form = _interopRequireDefault(require("react-bootstrap/Form"));
var _reactRedux = require("react-redux");
var _actions = require("../store/actions");
var _Asset = _interopRequireDefault(require("../assets/Asset 8.jpg"));
var _Asset2 = _interopRequireDefault(require("../assets/Asset 9.jpg"));
var _Asset3 = _interopRequireDefault(require("../assets/Asset 10.jpg"));
var _usersession = require("usersession");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// import { useRatesContext } from "../context/ratesContext";

const scrollToRef = ref => window.scrollTo(0, ref.current.offsetTop, {
  behavior: "smooth"
});
// General scroll to element function

function PropertyUsed() {
  // const { state, propertyUsedUpdate, ShowButtons } = useRatesContext();
  const userSession = new _usersession.UserSession();
  const [propertyUsed, setPropUsed] = (0, _react.useState)("");
  const dispatch = (0, _reactRedux.useDispatch)();
  const propertyUseRedux = (0, _reactRedux.useSelector)(state => state.nameReducer.propertyUse);
  // const propertyUseRedux = state.propertyUse;

  const myRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    //This function scroll the slider into view
    !localStorage.getItem("doNotScroll") && scrollToRef(myRef);
  }, []);
  (0, _react.useEffect)(() => {
    dispatch((0, _actions.ShowButtons)(false));
    // ShowButtons(false);

    setPropUsed(propertyUseRedux);
    userSession.setPropertyUse(propertyUseRedux);
    if (propertyUsed.length > 0) dispatch((0, _actions.ShowButtons)(true));
    // ShowButtons(true);
  }, [propertyUsed]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Form.default.Group, {
    className: "mb-0"
  }, /*#__PURE__*/_react.default.createElement(_Row.default, {
    className: "d-flex justify-content-center"
  }, /*#__PURE__*/_react.default.createElement(_Col.default, {
    lg: 12,
    className: "text-center mb-4"
  }, /*#__PURE__*/_react.default.createElement("h2", null, "How will this property be used?")), /*#__PURE__*/_react.default.createElement(_Col.default, {
    ref: myRef,
    lg: 3,
    className: "mb-4"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "overlay"
  }, /*#__PURE__*/_react.default.createElement(_Form.default.Check, {
    type: "radio",
    inline: true,
    id: "propPrimary",
    value: "1",
    label: "Primary Home",
    checked: propertyUsed === "1",
    onChange: e => {
      setPropUsed(e.target.value);
      dispatch((0, _actions.propertyUsedUpdate)(e.target.value));
      // propertyUsedUpdate(e.target.value);
    }
  }), /*#__PURE__*/_react.default.createElement("img", {
    src: _Asset.default,
    alt: "New Home",
    className: "radImg2 rounded-circle radImg customShadow ".concat(propertyUsed === "1" ? "d-none" : "")
  })), /*#__PURE__*/_react.default.createElement("h4", null, "Primary Home")), /*#__PURE__*/_react.default.createElement(_Col.default, {
    lg: 3,
    className: "mb-4"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "overlay"
  }, /*#__PURE__*/_react.default.createElement(_Form.default.Check, {
    type: "radio",
    id: "proInvestment",
    inline: true,
    value: "2",
    label: "Investment Property",
    checked: propertyUsed === "2",
    onChange: e => {
      setPropUsed(e.target.value);
      dispatch((0, _actions.propertyUsedUpdate)(e.target.value));
      // propertyUsedUpdate(e.target.value);
    }
  }), /*#__PURE__*/_react.default.createElement("img", {
    src: _Asset2.default,
    alt: "Piggy with a wood house",
    className: "radImg2 rounded-circle radImg customShadow ".concat(propertyUsed === "2" ? "d-none" : "")
  })), /*#__PURE__*/_react.default.createElement("h4", null, "Investment Property")), /*#__PURE__*/_react.default.createElement(_Col.default, {
    lg: 3,
    className: "mb-2"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "overlay"
  }, /*#__PURE__*/_react.default.createElement(_Form.default.Check, {
    type: "radio",
    inline: true,
    id: "propSecondary",
    value: "3",
    label: "Secondary Home",
    checked: propertyUsed === "3",
    onChange: e => {
      setPropUsed(e.target.value);
      dispatch((0, _actions.propertyUsedUpdate)(e.target.value));
      // propertyUsedUpdate(e.target.value);
    }
  }), /*#__PURE__*/_react.default.createElement("img", {
    src: _Asset3.default,
    alt: "House in the sand",
    className: "radImg2 rounded-circle radImg customShadow ".concat(propertyUsed === "3" ? "d-none" : "")
  })), /*#__PURE__*/_react.default.createElement("h4", null, "Secondary Home")))));
}